module.exports = __webpack_public_path__ + "d074cd9ea3f9116c2dac0f0191aa27d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarityScale/internallyFlawless@2x.png
// module id = 827
// module chunks = 0